module.exports = __webpack_public_path__ + "static/img/gggggg_03.29a6953.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_03.png
// module id = jcGU
// module chunks = 1